<template>
	<div class="country-item-list__collapse-header">
		<div :class="['country-item-list__collapse-title', { 'country-item-list__collapse-title--open': isOpen }]">
			<span class="country-item-list__collapse-text">
				{{ region.RegionGroupName }}
				<span class="country-item-list__region-count">
					{{ getRegionsCount(region.Regions) }}
				</span>
			</span>
			<span
				v-if="!isOpen"
				class="country-item-list__collapse-hint"
			>
				{{ collapseHintText(region.Regions) }}
			</span>
		</div>
		<span
			v-if="!isOpen"
			class="country-item-list__collapse-price"
		>
			<span class="country-item-list__collapse-price-hint">{{ TOTAL_PRICE_TEXT_REGION }}</span>
			{{ NBSP }}<BasePrice :price="bestPrices[region.code]" />
		</span>
	</div>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import type { BestOfferForRegion } from '@/interfaces/api/v1-best-offer-for-region';
import { TOTAL_PRICE_TEXT_REGION, NBSP } from '@global-js/constants';
import BasePrice from '@lmt-rpb/Atoms/BasePrice/BasePrice.vue';

interface Props {
	region: BestOfferForRegion & { code: string };
	isOpen: boolean;
	bestPrices: Record<string, number>;
	getRegionsCount: (regions: BestOfferForRegion['Regions']) => string;
	collapseHintText: (regions: BestOfferForRegion['Regions']) => string;
	formatPrice: (price: number) => string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.country-item-list {
	&__collapse-header {
		display: flex;
		align-items: center;
		width: calc(100% - 3rem);
	}

	&__collapse-title {
		display: flex;
		flex-direction: column;
		min-width: 0;
		flex: 1;
		color: $color-primary;
		font-size: $font-medium-3;
		font-weight: $font-weight-semibold;
		font-family: $font-family-special;
		align-items: baseline;

		@media (min-width: $breakpoint-small) {
			flex-direction: row;
		}

		&--open {
			width: 90%;
		}
	}

	&__collapse-text {
		display: block;
		padding-right: 1rem;
		color: $color-black;
		min-width: 40%;

		@include text-ellipsis(auto);

		width: -webkit-fill-available;
	}

	&__region-count {
		display: inline-block;
		color: $color-placeholder-text;
		font-size: $font-small-2;
		white-space: nowrap;
		vertical-align: text-top;
		font-weight: $font-weight-semibold;
	}

	&__collapse-hint {
		display: inline-block;
		color: $color-placeholder-text;
		font-size: $font-small-2;
		font-weight: $font-weight-semibold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 6rem;
		width: -webkit-fill-available;
		width: -moz-available;
		width: fill-available;
		text-align: left;

		@media (max-width: $breakpoint-verysmall) {
			margin-right: 1rem;
		}
	}

	&__collapse-price {
		margin-left: auto;
		color: $color-extra;
		font-size: $font-small-1;
		font-weight: $font-weight-semibold;
		white-space: nowrap;
		min-width: 8rem;
		text-align: right;

		@media (max-width: $breakpoint-medium) {
			min-width: 9rem;
		}
	}

	&__collapse-price-hint {
		font-size: $font-small-2;
		font-weight: $font-weight-regular;
		color: $color-black;
	}
}
</style>
